import { render, staticRenderFns } from "./SidebarLoading.vue?vue&type=template&id=1c6b0b87&"
import script from "./SidebarLoading.vue?vue&type=script&lang=js&"
export * from "./SidebarLoading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports